
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    var overlay = document.getElementById('lvy-exit-overlay');
    var noThanks = document.getElementById('lvy-no-thanks');
    var closeX = document.getElementById('lvy-close-x');
    var feedback = document.getElementById('lvy-feedback-button');
    if (!overlay) return;

    var path = String(window.location.pathname || '');
    var search = String(window.location.search || '');
    var hash = String(window.location.hash || '');

    var testMode =
      /(?:\?|&)lvy_survey_test=1(?:&|$)/.test(search) ||
      hash === '#lvy-survey-test';

    var eligiblePage =
      path.indexOf('/products/') !== -1 ||
      path === '/cart' ||
      /\/cart\/?$/.test(path);

    if (!eligiblePage && !testMode) return;

    var STORAGE_KEY = 'lvy_exit_survey_seen_v5';
    var COOLDOWN = 7 * 24 * 60 * 60 * 1000;
    var cartItemCount = 0;
    var cartStateReady = false;
    var cartRefreshInFlight = null;
    var armed = false;

    setTimeout(function () {
      armed = true;
    }, 2500);

    function recentlyShown() {
      if (testMode) return false;
      try {
        var t = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
        return !!t && (Date.now() - t < COOLDOWN);
      } catch (e) {
        return false;
      }
    }

    function markShown() {
      if (testMode) return;
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
    }

    function openSurvey() {
      if (recentlyShown()) return;
      overlay.classList.add('lvy-open');
      overlay.setAttribute('aria-hidden', 'false');
      markShown();
    }

    function closeSurvey() {
      overlay.classList.remove('lvy-open');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function refreshCartState() {
      if (cartRefreshInFlight) return cartRefreshInFlight;

      cartRefreshInFlight = fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart request failed');
          return res.json();
        })
        .then(function (cart) {
          cartItemCount = Number(cart && cart.item_count ? cart.item_count : 0);
          cartStateReady = true;
          return cartItemCount;
        })
        .catch(function () {
          cartStateReady = true;
          return cartItemCount;
        })
        .finally(function () {
          cartRefreshInFlight = null;
        });

      return cartRefreshInFlight;
    }

    function canShowSurvey() {
      if (testMode) return true;
      return eligiblePage && cartStateReady && cartItemCount > 0;
    }

    function tryOpenSurvey() {
      if (testMode) {
        openSurvey();
        return;
      }

      if (recentlyShown() || !eligiblePage) return;

      if (canShowSurvey()) {
        openSurvey();
        return;
      }

      refreshCartState().then(function (count) {
        if (count > 0 && !recentlyShown()) openSurvey();
      });
    }

    refreshCartState();

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = String(form.getAttribute('action') || '');
      if (action.indexOf('/cart/add') !== -1) {
        setTimeout(refreshCartState, 700);
        setTimeout(refreshCartState, 1600);
      }
    }, true);

    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest
        ? e.target.closest('button, input[type="submit"], a')
        : null;
      if (!target) return;

      var text = String(target.textContent || target.value || '').toLowerCase();
      var name = String(target.getAttribute && target.getAttribute('name') || '').toLowerCase();

      if (
        text.indexOf('add to cart') !== -1 ||
        text.indexOf('add to bag') !== -1 ||
        name === 'add'
      ) {
        setTimeout(refreshCartState, 700);
        setTimeout(refreshCartState, 1600);
      }
    }, true);

    window.addEventListener('focus', refreshCartState);
    window.addEventListener('pageshow', refreshCartState);

    // Reliable desktop pre-exit trigger:
    // fire while the cursor is still inside the webpage, just before it enters browser chrome.
    document.addEventListener('mousemove', function (e) {
      if (
        window.innerWidth > 768 &&
        armed &&
        typeof e.clientY === 'number' &&
        e.clientY <= 8
      ) {
        tryOpenSurvey();
      }
    }, { passive: true });

    // Keep conventional exit-intent triggers as fallbacks.
    document.addEventListener('mouseout', function (e) {
      e = e || window.event;
      var y = typeof e.clientY === 'number' ? e.clientY : 999;
      var related = e.relatedTarget || e.toElement;
      if ((y <= 25 || y < 0) && !related) {
        tryOpenSurvey();
      }
    });

    document.documentElement.addEventListener('mouseleave', function (e) {
      if (!e || typeof e.clientY !== 'number' || e.clientY <= 25) {
        tryOpenSurvey();
      }
    });

    // Mobile fallback for carted shoppers.
    var mobileArmed = false;
    setTimeout(function () {
      mobileArmed = true;
    }, 20000);

    window.addEventListener('scroll', function () {
      if (
        window.innerWidth <= 768 &&
        mobileArmed &&
        window.scrollY > 250
      ) {
        tryOpenSurvey();
      }
    }, { passive: true });

    // Forced test mode.
    if (testMode) {
      setTimeout(openSurvey, 600);
    }

    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#lvy-survey-test') {
        testMode = true;
        setTimeout(openSurvey, 100);
      }
    });

    if (noThanks) noThanks.addEventListener('click', closeSurvey);
    if (closeX) closeX.addEventListener('click', closeSurvey);
    if (feedback) feedback.addEventListener('click', closeSurvey);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSurvey();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSurvey();
    });

    window.LVYExitSurvey = {
      refreshCartState: refreshCartState,
      tryOpenSurvey: tryOpenSurvey,
      openSurvey: openSurvey
    };
  });
})();
